<template>
  <div class="ws-modal">
    <form
      class="ws-modal__form"
      @submit.prevent="submit"
    >
      <header class="ws-modal__header">
        <h2 class="has-text-weight-bold is-size-1">
          <span
            v-if="!isNewItem"
            v-text="$t('Редактировать группу')"
          ></span>
          <span
            v-else
            v-text="$t('Создать группу')"
          ></span>
        </h2>
      </header>
      <div class="ws-modal__content">
        <div class="columns is-multiline">
          <p class="column is-12">Общие сведения</p>
          <div class="column is-6">
            <b-field
              class="ws-field is-required"
              :label="$t('Название группы')"
              :type="{'is-danger': errors.has('name')}"
              :message="errors.first('name')"
            >
              <b-input
                class="ws-field__control"
                v-model="newItem.name"
                v-validate="{ required: true }"
                name="name"
              />
            </b-field>
          </div>
          <div class="column is-6">
            <b-field
              class="ws-field is-required"
              :label="$t('Учебный год')"
              :type="{'is-danger': errors.has('education_year')}"
              :message="errors.first('education_year')"
            >
              <b-select
                class="ws-field__control"
                v-model="newItem.education_year"
                expanded
              >
                <option
                  v-for="year in getYearsRangeList"
                  :value="year"
                  :key="year"
                >
                  {{ year }} / {{ year + 1}}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">

            <b-field
              class="ws-field ws-field-refbook-custom is-required"
              :label="$t('Код профессии/Специальности')"
              :type="{'is-danger': errors.has('prof_code')}"
              :message="errors.first('prof_code')"
            >
              <ws-refbook-field
                entity="public/refbook/education/program"
                name="prof_code"
                field="code"
                :isFocus="true"
                search-key="code"
                :data-vv-as="$t('Код профессии/Специальности')"
                @change="selectProgramm"
                v-model="getEduProgramCode"
                v-validate="{ required: true }"
              >
                <!-- :guid.sync="edu_program_code.guid"
                :item.sync="edu_program_code.item" -->
                <template
                  slot="item"
                  slot-scope="option"
                >
                  <div class="columns is-marginless is-paddingless">
                    <div class="column is-7 is-marginless is-paddingless">
                      <div style="white-space: normal;">
                        <span>
                          {{ option.option.code }}
                        </span>
                        <span
                          v-if="option.option.level.title.display"
                          class="has-text-grey"
                        >
                          | {{option.option.level.title.display}}
                        </span>
                      </div>
                    </div>
                    <div class="column is-5 is-marginless is-paddingless has-text-right ">
                      <small
                        class="has-text-grey"
                        style="white-space: normal;"
                      >
                        {{option.option.title.display}}
                      </small>
                    </div>
                  </div>
                </template>
                <template
                  slot="empty"
                  v-text="$t('Ничего не найдено')"
                ></template>
              </ws-refbook-field>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field
              class="ws-field ws-field-refbook-custom"
              :label="$t('Наименование профессии/Специальности')"
              :type="{'is-danger': errors.has('program')}"
              :message="errors.first('program')"
            >
              <ws-refbook-field
                entity="public/refbook/education/program"
                name="program"
                field="title.display"
                :isFocus="true"
                :data-vv-as="$t('Профессия/специальность (ДЭ)')"
                @change="selectProgramm"
                v-model="getProgramTitle"
                v-validate="{ required: true }"
              >
                <!-- :guid.sync="program.guid"
                :item.sync="program.item" -->
                <template
                  slot="item"
                  slot-scope="option"
                >
                  <div class="columns is-marginless is-paddingless">
                    <div class="column is-4 is-marginless is-paddingless">
                      <div style="white-space: normal;">
                        {{option.option.title.display}}
                      </div>
                    </div>
                    <div class="column is-8 is-marginless is-paddingless has-text-right">
                      <small
                        class="has-text-grey"
                        style="white-space: normal;"
                      >
                        <span
                          v-if="option.option.level.title.display"
                          class="has-text-grey"
                        >
                          {{option.option.level.title.display}} |
                        </span>
                        <span>
                          {{ option.option.code }}
                        </span>
                      </small>
                    </div>
                  </div>
                </template>
                <template
                  slot="empty"
                  v-text="$t('Ничего не найдено')"
                ></template>
              </ws-refbook-field>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field
              class="ws-field is-required"
              :label="$t('Программа подготовки и уровень (определена на основе кода)')"
            >
              <b-input
                class="ws-field__control"
                disabled
                :value="newItem.edu_program.level.title.translate ? newItem.edu_program.level.title.translate.ru : ''"
                name="specialization"
              />
            </b-field>
          </div>
          <div class="column is-6">
            <b-field
              class="ws-field is-required"
              :label="$t('Форма обучения')"
              :type="{'is-danger': errors.has('education_form')}"
              :message="errors.first('education_form')"
            >
              <b-select
                class="ws-field__control"
                name="education_form"
                v-validate="{ required: true }"
                v-model="newItem.education_form"
                expanded
              >
                <option value="full-time">{{ $t('Очная') }}</option>
                <option value="part-time">{{ $t('Очно-заочная') }}</option>
                <option value="remote">{{ $t('Заочная') }}</option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field
              class="ws-field is-required"
              :type="{'is-danger': errors.has('education_year_start')}"
              :message="errors.first('education_year_start')"
              :label="$t('Календарный год начала обучения')"
            >
              <b-select
                class="ws-field__control"
                v-model.number="newItem.education_year_start"
                name="education_year_start"
                v-validate="{ required: true, min: 1 }"
                expanded
              >
                <option
                  v-for="year in getEducationsYearsRangeList"
                  :value="year"
                  :key="year"
                >
                  {{ year }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field
              class="ws-field is-required"
              :type="{'is-danger': errors.has('education_year_finish')}"
              :message="errors.first('education_year_finish')"
              :label="$t('Календарный год завершения обучения')"
            >
              <b-select
                class="ws-field__control"
                v-model.number="newItem.education_year_finish"
                name="education_year_finish"
                v-validate="{ required: true }"
                expanded
              >
                <option
                  v-for="year in getEducationsYearsRangeList"
                  :value="year"
                  :key="year"
                >
                  {{ year }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field
              class="ws-field is-required"
              :type="{'is-danger': errors.has('education_year_current')}"
              :message="errors.first('education_year_current')"
              :label="$t('Курс обучения (текущий)')"
            >
              <b-select
                class="ws-field__control"
                v-model.number="newItem.education_year_current"
                name="education_year_current"
                v-validate="{ required: true }"
                expanded
              >
                <option v-for="year in educationalCourseOptions" :key="year" :value="year">{{ year }}</option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field
              class="ws-field is-required"
              :type="{'is-danger': errors.has('education_years_total')}"
              :message="errors.first('education_years_total')"
              :label="$t('Курс обучения (всего)')"
            >
              <b-select
                class="ws-field__control"
                v-model.number="newItem.education_years_total"
                name="education_years_total"
                v-validate="{ required: true }"
                expanded
              >
                <option v-for="year in educationalCourseOptions" :key="year" :value="year">{{ year }}</option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="columns is-multiline" v-if="is_in_prof_cluster || newItem.edu_program_is_prof">
          <p class="column is-12">Учебная группа обучается по образовательной программе кластера ФП Профессионалитет</p>
          <div class="column is-6">
            <b-field
              class="ws-field is-required"
              style="margin: 0"
              :type="{'is-danger': errors.has('edu_program_is_prof')}"
              :message="errors.first('edu_program_is_prof')"
              :label="$t('Да / Нет')"
            >
              <b-select
                class="ws-field__control"
                :disabled="!this.is_in_prof_cluster"
                v-model="newItem.edu_program_is_prof"
                name="edu_program_is_prof"
                v-validate="{ required: true }"
                expanded
              >
                <option :value="true">{{ $t('Да') }}</option>
                <option :value="false">{{ $t('Нет') }}</option>
              </b-select>
            </b-field>
            <p v-if="!this.is_in_prof_cluster" class="column is-12" style="color: #808080; padding: 0">*ОО не включена в кластер, статус не активен</p>
          </div>
        </div>

        <div class="columns is-multiline">
          <p class="column is-12">Срок получения образования по образовательной программе</p>
          <div class="column is-6">
            <b-field
              class="ws-field is-required"
              :label="$t('Срок обучения, год(ы)')"
              :type="{'is-danger': errors.has('edu_period_years')}"
              :message="errors.first('edu_period_years')"
            >
              <b-select
                class="ws-field__control"
                v-model.number="item.edu_period_years"
                name="edu_period_years"
                data-vv-as="Срок обучения, год(ы)"
                placeholder="Введите срок обучения"
                v-validate="{ required: true }"
                expanded
              >
               <option v-for="yarn in educationalPeriodYears" :key="yarn" :value="yarn">{{ yarn }}</option>
              </b-select>
          </b-field>
          </div>
          <div class="column is-6">
            <b-field
              class="ws-field is-required"
              :label="$t('Срок обучения, мес.')"
              :type="{'is-danger': errors.has('edu_period_months')}"
              :message="errors.first('edu_period_months')"
            >
              <b-select
                class="ws-field__control"
                v-model.number="item.edu_period_months"
                name="edu_period_months"
                data-vv-as="Срок обучения, мес."
                placeholder="Введите срок обучения"
                v-validate="{ required: true }"
                expanded
              >
               <option v-for="yarn in educationalPeriodYears" :key="yarn" :value="yarn">{{ yarn }}</option>
              </b-select>
          </b-field>
          </div>
        </div>
        <div  class="columns is-multiline evaluation-table">
          <p class="column is-12 ">Общие сведения</p>
          <div v-for="(item) in [2, 3, 4, 5]" :key="item" class="column is-12 columns is-multiline">
            <div class="column is-4">
              <b-field
                label="Оценка ГИА"
                class="ws-field is-required"
              >
                <b-input
                  class="ws-field__control"
                  :value="`${item} ${getPluralString(['балл','балла','баллов'], item)}`"
                  data-vv-as="Оценка ГИА"
                  placeholder="Оценка ГИА"
                  aria-label="Оценка ГИА"
                  :disabled="true"
                />
              </b-field>
            </div>
            <div class="column is-4">
              <b-field
                v-if="item === 2"
                label="Нижний порог (от, включая), %"
                class="ws-field is-required"
              >
                <b-input
                  :value="0"
                  class="ws-field__control"
                  data-vv-as="Нижний порог (от, включая), %"
                  placeholder="Введите значение"
                  aria-label="Нижний порог (от, включая), %"
                  :disabled="true"
                />
              </b-field>
              <b-field
                v-else
                label="Нижний порог (от, включая), %"
                class="ws-field is-required"
                :message="errors.first(`lower_threshold_${item}`)"
                :type="{ 'is-danger': errors.has(`lower_threshold_${item}`) }"
              >
                <b-input
                  v-model.number="evaluation[`lower_threshold_${item}`]"
                  v-validate="{ max_value: 99, required: true, min_value: 0 }"
                  class="ws-field__control"
                  :min="1"
                  :max="99"
                  type="number"
                  step="any"
                  :name="`lower_threshold_${item}`"
                  data-vv-as="Нижний порог"
                  placeholder="Введите значение"
                  aria-label="Нижний порог (от, включая), %"
                />
              </b-field>
            </div>
            <div class="column is-4">
              <b-field
                v-if="item === 5"
                class="ws-field is-required"
                label="Верхний порог (от, не включая), %"
              >
                <b-input
                  :value="100"
                  class="ws-field__control"
                  placeholder="Введите значение"
                  data-vv-as="Верхний порог (от, не включая), %"
                  aria-label="Верхний порог (от, не включая), %"
                  :disabled="true"
                />
              </b-field>
              <b-field
                v-else
                class="ws-field is-required"
                label="Верхний порог (от, не включая), %"
                :message="errors.first(`upper_threshold_${item}`)"
                :type="{ 'is-danger': errors.has(`upper_threshold_${item}`) }"
              >
                <b-input
                  v-model.number="evaluation[`upper_threshold_${item}`]"
                  v-validate="{ max_value: 99, required: true, min_value: 0 }"
                  placeholder="Введите значение"
                  class="ws-field__control"
                  type="number"
                  :min="1"
                  :max="99"
                  :name="`upper_threshold_${item}`"
                  step="any"
                  data-vv-as="Верхний порог"
                  aria-label="Верхний порог (от, не включая), %"
                />
              </b-field>
            </div>
        </div>
      </div>
        <div v-if="!isNewItem" class="columns is-multiline">
            <p class="column is-12">Документы</p>
            <dl
            v-for="file in array_file" :key="file.label"
             class="ws-exam-groups-meta__docs__item column is-12">
              <div class="columns is-12">
                <dt class="column is-6">
                  <b-field
                    class="ws-field"
                    :label="$t('Тип документа')"
                    :type="{ 'is-danger': errors.has('type') }"
                    :message="errors.first('type')"
                  >
                    <b-select
                      class="ws-field__control"
                      name="type"
                      :placeholder="$t('')"
                      value='1'
                      expanded
                      disabled
                    >
                      <option
                        value="1"
                        v-text="file.label"
                      ></option>
                    </b-select>
                  </b-field>
                </dt>
                <dd class="column is-6 align-center" v-if="files[file.name]">
                  <span class="has-text-success has-text-weight-bold mr-5">{{ $t('Загружен') }} </span>
                    <file-download
                      class="is-size-3 is-inline-block"
                      :file="files[file.name][0]"
                      :isShowFileDate="true"
                      :buttonLabel="''"
                      @remove="removeFile(file.name)"
                    />
                </dd>
              </div>
              <div class="columns is-multiline">
                <div class="column is-6">
                    <file-upload
                      class="is-full"
                      :category="file.name"
                      :item-guid="item.guid"
                      :path-url="`/api/de/proxy/general-files/add/category/`"
                      @uploaded="uploadFile"
                      :buttonLabel="$t('Загрузить .pdf')"
                      accept="application/pdf"
                    />
                </div>
              </div>
            </dl>
            <b-loading
                  :active="isUploadPending"
                  :is-full-page="false"
                  :can-cancel="true"
            />
        </div>
        <div v-else>
          <p class="has-text-centered">Добавление документов доступно после создания группы</p>
        </div>
      </div>
      <footer class="ws-modal__footer">
        <div class="columns">
          <div class="column is-8"></div>
          <div class="column is-4 is-vcentered">
            <div class="has-text-right-desktop">
              <button class="ws-button button is-large is-primary is-fullwidth">
                <span
                  class="is-size-4 has-text-weight-bold"
                  v-if="!isNewItem"
                  v-text="$t('Редактировать')"
                ></span>
                <span
                  class="is-size-4 has-text-weight-bold"
                  v-else
                  v-text="$t('Создать')"
                ></span>
              </button>
            </div>
          </div>
        </div>
      </footer>
    </form>
    <aside class="ws-modal__sidebar">
      <button
        class="ws-button button is-text"
        @click="close"
      >
        <ws-icon
          class="ws-button__icon"
          name="close-thin"
          color="#000000"
          :fill="true"
          :title="$t('Закрыть')"
          width="17"
          height="18"
        />
      </button>
    </aside>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { ARRAY_FILE } from './const/index.ts'
import getPluralString from '@/utils/getPluralString'
const nullGuid = '00000000-0000-0000-0000-000000000000'

export default {
  name: 'WsStudyGroupForm',
  props: {
    educationGuid: String,
    is_in_prof_cluster: Boolean,
    item: {
      type: Object,
      default: () => {
        return {
          university: {
            guid: null
          },
          name: '',
          education_year: new Date().getFullYear() - 1,
          edu_program: {
            guid: null,
            title: {
              translate: {
                ru: null
              }
            },
            level: {
              title: {
                translate: {
                  ru: null
                }
              }
            },
            code: null
          }
        }
      }
    }
  },
  data () {
    return {
      newItem: this.item,
      // is_in_prof_cluster: false,
      program: {
        title: {
          translate: {
            ru: ''
          }
        },
        guid: null,
        item: null,
        code: null
      },
      edu_program_code: {
        guid: null,
        title: {
          translate: {
            ru: null
          }
        },
        code: null
      },
      specialization: {
        title: {
          translate: {
            ru: ''
          }
        }
      },
      evaluation: {
        upper_threshold_2: this.item.upper_threshold_2,
        upper_threshold_3: this.item.upper_threshold_3,
        upper_threshold_4: this.item.upper_threshold_4,
        lower_threshold_3: this.item.lower_threshold_3,
        lower_threshold_4: this.item.lower_threshold_4,
        lower_threshold_5: this.item.lower_threshold_5
      },
      files: {
        'academic-calendar': null,
        'order-gek': null,
        'order-gek-structure': null,
        'gia-program-list': null,
        'gia-admission': null,
        'de-plan-list': null
      },
      array_file: ARRAY_FILE,
      isUploadPending: false
    }
  },
  watch: {
    educationGuid: {
      immediate: true,
      deep: true,
      handler (value) {
        this.newItem.university.guid = value
      }
    },

    evaluation: {
      deep: true,
      immediate: true,
      handler (item) {
        this.item.lower_threshold_3 = item.lower_threshold_3
        this.item.lower_threshold_4 = item.lower_threshold_4
        this.item.lower_threshold_5 = item.lower_threshold_5
        this.item.upper_threshold_2 = item.upper_threshold_2
        this.item.upper_threshold_3 = item.upper_threshold_3
        this.item.upper_threshold_4 = item.upper_threshold_4
      }
    },
    item: {
      deep: true,
      immediate: true,
      handler (item) {
        this.newItem = item
        if (item.edu_program && item.edu_program.guid && item.edu_program.guid !== nullGuid) {
          this.program.title.translate.ru = item.edu_program.title.translate.ru
          this.program.code = item.edu_program.code
          this.program.guid = item.edu_program.guid
          this.program.item = item.edu_program
          this.edu_program_code = JSON.parse(JSON.stringify(this.program))
          this.edu_program_code.guid = `${this.edu_program_code.guid}_code`
        }
        if (!this.newItem.education_year) {
          this.newItem.education_year = new Date().getFullYear() - 1
        }

        if (!this.newItem.education_year_current) {
          this.newItem.education_year_current = ''
        }

        if (!this.newItem.education_year_finish) {
          this.newItem.education_year_finish = ''
        }

        if (!this.newItem.education_year_start) {
          this.newItem.education_year_start = ''
        }

        if (!this.newItem.education_years_total) {
          this.newItem.education_years_total = ''
        }

        // this.is_in_prof_cluster = this.item.university.is_in_prof_cluster
      }
    }
  },
  computed: {
    ...mapState('de-centers', {
      isDeCenterPending: 'isFindPending'
    }),
    ...mapState('competence', {
      isCompetencePending: 'isFindPending'
    }),
    getProgramTitle: {
      get () {
        return this.program.title.translate.ru
      },
      set (val) {
        if (val) this.program.title.translate.ru = val
        else this.clearFieldsProgramAndEduProgramCode()
      }
    },
    getEduProgramCode: {
      get () {
        return this.edu_program_code.code
      },
      set (val) {
        if (val) this.edu_program_code.code = val
        else this.clearFieldsProgramAndEduProgramCode()
      }
    },
    getYearsRangeList () {
      const currentYear = new Date().getFullYear()
      return [currentYear - 1, currentYear, currentYear + 1]
    },
    getEducationsYearsRangeList () {
      const start = 2015
      const end = 2035
      return [...Array(end - start + 1)].map((_, i) => start + i)
    },
    isNewItem () {
      return !(this.newItem && this.newItem.guid)
    },
    educationalCourseOptions () {
      return Array.from({ length: 7 }).map((_, value) => value + 1)
    },
    educationalPeriodYears () {
      return [...Array(11).keys()].map(value => value)
    },
    educationalPeriodMonth () {
      return [...Array(12).keys()].map(value => value)
    }
  },
  methods: {
    ...mapActions('refbook/study_groups', ['create', 'update']),
    ...mapActions('profile/files', {
      getFileByRecId: 'getFileByRecId',
      removeFileByRecId: 'removeFileByRecId'
    }),
    getPluralString,
    clearFieldsProgramAndEduProgramCode () {
      this.program.guid = null
      this.program.item = null
      this.program.code = null
      this.program.title.translate.ru = ''

      this.edu_program_code.guid = null
      this.edu_program_code.item = null
      this.edu_program_code.title.translate.ru = ''
      this.edu_program_code.code = null

      this.$nextTick(() => {
        this.program.guid = null
        this.program.item = null
        this.program.code = null
        this.program.title.translate.ru = ''

        this.edu_program_code.guid = null
        this.edu_program_code.item = null
        this.edu_program_code.title.translate.ru = ''
        this.edu_program_code.code = null

        this.selectProgramm()
      })
    },
    selectProgramm (e) {
      if (e && e.title && e.guid && e.code && e.level) {
        this.newItem.edu_program.guid = e.guid
        this.newItem.edu_program.code = e.code
        this.newItem.edu_program.title.translate.ru = e.title.translate.ru
        this.newItem.edu_program.level.title.translate = {
          ru: e.level.title.translate ? e.level.title.translate.ru : ''
        }
      } else {
        this.newItem.edu_program.guid = null
        this.newItem.edu_program.code = null
        this.newItem.edu_program.title.translate.ru = null
        this.newItem.edu_program.level.title.translate.ru = null
      }
    },
    async submit () {
      if (!this.files['academic-calendar'] && !this.isNewItem) {
        this.$buefy.toast.open({
          message: this.$t('Загрузите календарный учебный график'),
          type: 'is-danger'
        })
        return
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.isNewItem) {
            this.create(this.newItem)
            this.$buefy.toast.open({
              message: this.$t(`Группа ${this.newItem.name} успешно создана`),
              type: 'is-success'
            })
            this.$emit('createGroup')
          } else {
            this.update([this.newItem.guid, this.newItem])
            this.$buefy.toast.open({
              message: this.$t(`Группа ${this.newItem.name} успешно обновлена`),
              type: 'is-success'
            })
            this.$emit('updateGroup')
          }
          this.$parent.close()
        }
      }).catch(() => this.$buefy.toast.open({
        message: this.$t(`Что-то пошло не так.`),
        type: 'is-danger'
      }))
    },
    close () {
      this.$parent.close()
    },
    async removeFile (category) {
      const file = this.files[category][0]
      this.$buefy.dialog.confirm({
        title: this.$t(`Вы действительно хотите удалить файл ${file.file_name}?`),
        cancelText: this.$t('Отмена'),
        confirmText: this.$t('Удалить'),
        type: 'is-danger',
        onConfirm: async function () {
          try {
            await this.removeFileByRecId({
              isProxy: true,
              'rec-guid': this.item.guid,
              'category': category,
              'file-guid': file.guid
            })
            this.files[category] = null
          } catch (e) {
            console.log(e)
          }
        }.bind(this)
      })
    },
    async uploadFile (files, category) {
      this.files[category] = files
    },
    async getFile (category) {
      const files = await this.getFileByRecId({
        'rec-guid': this.item.guid,
        'category': category
      })
      this.files[category] = files
    },
    async getFiles () {
      this.isUploadPending = true
      const arrRequests = Object.keys(this.files)
        .map(elem => this.getFile(elem))
      await Promise.all(arrRequests).finally(() => {
        this.isUploadPending = false
      })
    }
  },
  async mounted () {
    await this.getFiles()
  }
}
</script>
<style lang="scss" scoped>
.ws-modal {
  max-width: 100%;
}
</style>
<style lang="scss">
.ws-field-refbook-custom {
  a.dropdown-item {
    padding-right: 1rem;
  }
}

.evaluation-table{
  .columns{
    margin-bottom: 0;
  }
}
.ws-exam-groups-meta__docs__item{
  padding: 0.75rem;
}
</style>
